import routes from './sefaz.routes';

export const sefazModule = {
    routes
};
